import { AxiosGlobalFilters } from '../config';

export const PermissionService = {
  getPermissions: ({ empresa, unidade }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `v1/permissoes?empresaId=${empresa}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
        UnidadeId: unidade,
      },
    });
  },
  savePermission: ({ usuariosIds, unidadesIds, empresa, permissaoId }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: 'v1/usuarios/permissoes',
      data: {
        usuariosIds,
        permissaoId,
        unidadesIds,
        EmpresaId: empresa,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
};
